/**
 * Central SEO metadata for all static pages (marketing, products, hub listings, 404).
 * Edit titles, descriptions, canonical paths, and hub hero copy (h1, heroDescription) here
 */
export const STATIC_PAGE_SEO_META = {
  home: {
    pageTitle: 'AI Claims Intelligence Platform for Insurance Carriers | Charlee.ai',
    metaDescription:
      'Charlee helps insurance carriers improve claims outcomes with AI-powered claims intelligence, litigation prediction, fraud detection, document summarization, and underwriting analytics.',
    canonicalPath: '/',
  },
  about: {
    pageTitle: 'About Charlee.ai | AI Innovation for Insurance Claims & Underwriting',
    metaDescription:
      'Learn how Charlee combines insurance expertise, AI, and predictive analytics to help carriers improve claims and underwriting performance.',
    canonicalPath: '/about',
  },
  partners: {
    pageTitle: 'Partners | Charlee.ai',
    metaDescription:
      'Partner with Charlee.ai to deliver AI-powered claims and underwriting solutions. Explore partnership opportunities with leading insurers and technology providers.',
    canonicalPath: '/partners',
  },
  contact: {
    pageTitle: 'Request an Insurance AI Demo | Charlee.ai',
    metaDescription:
      'Schedule a personalized demo to see how Charlee helps insurers predict claim severity, reduce litigation, detect fraud, and improve underwriting decisions.',
    canonicalPath: '/contact',
  },
  solutions: {
    pageTitle: 'Insurance AI Solutions for Claims & Underwriting | Charlee.ai',
    metaDescription:
      "Explore Charlee's insurance AI solutions for claims severity prediction, litigation risk, fraud detection, claims document intelligence, and underwriting optimization.",
    canonicalPath: '/solutions',
  },
  videos: {
    pageTitle: 'Product Videos | Charlee.ai',
    metaDescription:
      'Watch Charlee.ai product overview and demo videos — learn how our AI platform supports claims, DocuCharlee, user roles, and proof-of-concept workflows.',
    canonicalPath: '/videos',
  },
  notFound: {
    pageTitle: 'Page Not Found | Charlee.ai',
    metaDescription:
      'This Charlee.ai page could not be found. Return to the homepage or explore our insights on AI for insurance claims and underwriting.',
  },
  products: {
    askcharlee: {
      pageTitle: 'Insurance Claims AI Assistant & Search Platform | AskCharlee',
      metaDescription:
        'AskCharlee enables insurance professionals to search claims, documents, notes, and policy information using natural language and generative AI.',
      canonicalPath: '/product/askcharlee',
    },
    seecharlee: {
      pageTitle: 'Claims Severity & Litigation Prediction Software | 4SeeCharlee',
      metaDescription:
        'Predict claim severity, attorney involvement, and litigation risk early so adjusters can intervene before losses escalate and reserves increase.',
      canonicalPath: '/product/seecharlee',
    },
    docucharlee: {
      pageTitle: 'AI Claims Document Summarization Software | DocuCharlee',
      metaDescription:
        'Automatically summarize claim files, medical records, legal documents, and adjuster notes with AI-powered insurance document intelligence.',
      canonicalPath: '/product/docucharlee',
    },
    findcharlee: {
      pageTitle: 'Insurance Fraud Detection Software & Claims Analytics | FindCharlee',
      metaDescription:
        'Detect suspicious claims earlier with AI-powered fraud analytics, automated fraud indicators, and investigation support for insurance SIU teams.',
      canonicalPath: '/product/findcharlee',
    },
    ritecharlee: {
      pageTitle: 'Insurance Underwriting Intelligence Platform | RiteCharlee',
      metaDescription:
        'Improve underwriting performance with AI-driven risk intelligence, predictive analytics, and portfolio insights designed for insurance carriers.',
      canonicalPath: '/product/ritecharlee',
    },
  },
  hub: {
    all: {
      pageTitle: 'Insurance AI Resources, Insights & Research | Charlee.ai',
      metaDescription:
        'Explore expert insights on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      h1: 'Insurance AI Insights and Research',
      heroDescription:
        'Explore expert insights on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      canonicalPath: '/articles/all',
    },
    events: {
      pageTitle: 'Insurance AI Events, Webinars & Meetups | Charlee.ai',
      metaDescription:
        'Explore events and webinars on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      h1: 'Insurance AI Events, Webinars and Meetups',
      heroDescription:
        'Explore events and webinars on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      canonicalPath: '/articles/events',
    },
    news: {
      pageTitle: 'Insurance AI News, Updates & Announcements | Charlee.ai',
      metaDescription:
        'Explore the latest news on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      h1: 'Insurance AI News, Updates and Announcements',
      heroDescription:
        'Explore the latest news on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      canonicalPath: '/articles/news',
    },
    podcasts: {
      pageTitle: 'Insurance AI Podcasts, Conversations & Expert Insights | Charlee.ai',
      metaDescription:
        'Explore expert podcast conversations on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      h1: 'Insurance AI Podcasts and Expert Insights',
      heroDescription:
        'Explore expert podcast conversations on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      canonicalPath: '/articles/podcasts',
    },
    blogs: {
      pageTitle: 'Insurance AI Blogs, Articles & Expert Insights | Charlee.ai',
      metaDescription:
        'Explore expert blog insights on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      h1: 'Insurance AI Blogs and Expert Insights',
      heroDescription:
        'Explore expert blog insights on insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      canonicalPath: '/articles/blogs',
    },
    usecases: {
      pageTitle: 'Insurance AI Use Cases, Examples & Success Stories | Charlee.ai',
      metaDescription:
        'Explore real-world use cases for insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      h1: 'Insurance AI Use Cases and Success Stories',
      heroDescription:
        'Explore real-world use cases for insurance AI, claims analytics, litigation prediction, fraud detection, underwriting intelligence, and industry trends.',
      canonicalPath: '/articles/usecases',
    },
  },
};

/** Hub listing sections — alias for STATIC_PAGE_SEO_META.hub */
export const HUB_SECTION_META = STATIC_PAGE_SEO_META.hub;
